import React from 'react'
import PropTypes from 'prop-types'

import videojs from 'video.js'

import 'video.js/dist/video-js.css'
import './video.styl'
class VideoForm extends React.Component {
    componentDidMount() {
        // instantiate video.js
        this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
            console.log('onPlayerReady', this)
        });
    }

    // destroy player on unmount
    componentWillUnmount() {
        if (this.player) {
            this.player.dispose()
        }
    }

    // wrap the player in a div with a `data-vjs-player` attribute
    // so videojs won't create additional wrapper in the DOM
    // see https://github.com/videojs/video.js/pull/3856
    render() {
        let {className=''} = this.props;
        return <div data-vjs-player className={"form form-video" + className}>
            <video ref={node => this.videoNode = node} className="video-js"></video>
        </div>
    }
}

VideoForm.propTypes = {
    className: PropTypes.string,
    options: PropTypes.shape({
        autoplay: PropTypes.bool,
        controls: PropTypes.bool,
        sources: PropTypes.arrayOf(
            PropTypes.shape({
                src: PropTypes.string,
                type: PropTypes.string
            })
        ).isRequired
    }).isRequired
}

export default VideoForm
